// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1398":"9caba937","2122":"9caba937","2173":"d65a8647","4395":"e35288c9","5899":"f39ef349","6035":"f39ef349","6404":"ec0eedfe","7193":"afd5edd3","9754":"01a4bee1"}[chunkId] + ".chunk.css";
};